import apiClient from "./apiClient";

export const fetchStateProcurements = async () => {
    const response = await apiClient.get("/api/zakupki/all");
    return response.data;
};

export const updateStateProcurement = async (id, data) => {
    const response = await apiClient.put(`/api/zakupki/${id}`, data);
    return response.data;
};